const IconLeading = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 13C13.6937 13 12.5825 13.8349 12.1707 15.0001L4 15V17L12.171 17.0009C12.5831 18.1656 13.6941 19 15 19C16.3059 19 17.4169 18.1656 17.829 17.0009L20 17V15L17.8293 15.0001C17.4175 13.8349 16.3063 13 15 13ZM15 15C15.5523 15 16 15.4477 16 16C16 16.5128 15.614 16.9355 15.1166 16.9933L15 17C14.4477 17 14 16.5523 14 16C14 15.4872 14.386 15.0645 14.8834 15.0067L15 15ZM9 5C10.3063 5 11.4175 5.83485 11.8293 7.00009L20 7V9L11.829 9.0009C11.4169 10.1656 10.3059 11 9 11C7.69412 11 6.58311 10.1656 6.17102 9.0009L4 9V7L6.17067 7.00009C6.58249 5.83485 7.69375 5 9 5ZM9 7C8.44772 7 8 7.44772 8 8C8 8.51284 8.38604 8.93551 8.88338 8.99327L9 9C9.55228 9 10 8.55228 10 8C10 7.48716 9.61396 7.06449 9.11662 7.00673L9 7Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconLeading;
